"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Step1_1 = __importDefault(require("./Step1"));
var Step2_1 = __importDefault(require("./Step2"));
var ForgotPassword = function (_a) {
    var withLabels = _a.withLabels;
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var _b = (0, react_1.useState)(0), step = _b[0], setStep = _b[1];
    var setNextStep = (0, react_1.useCallback)(function () {
        setStep(1);
    }, [setStep]);
    var _c = (0, swr_hooks_1.useForgotPassword)({
        successAction: setNextStep,
    }), forgotPassword = _c.forgotPassword, error = _c.error, isSubmitting = _c.isSubmitting;
    return (react_1.default.createElement(ui_components_1.Modal, { width: "320px", height: "auto", saveSize: true, onClose: closeWindow },
        react_1.default.createElement(ui_components_1.ModalTitle, null,
            react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: t('forgotPassQuestion'),
                } })),
        step === 0 ? (react_1.default.createElement(Step1_1.default, { forgotPassword: forgotPassword, error: error, isSubmitting: isSubmitting, withLabels: withLabels })) : (react_1.default.createElement(Step2_1.default, null))));
};
exports.default = ForgotPassword;
